import './checklist.component.scoped.scss'

export type ItemList = {
  message?: string
  status?: string
}

type Props = {
  checkList?: ItemList[]
}

export default ({ checkList }: Props) => {
  return checkList?.length > 0 ? (
    <ul className="checklist">
      {checkList?.map((item, i) => (
        <li key={i} className="item">
          {item?.status === 'success' && <i className="fa-solid fa-check mr-3" style={{ color: 'var(--gray)' }}></i>}
          {item?.status === 'error' && <i className="fa-solid fa-xmark mr-3" style={{ color: 'var(--gray)' }}></i>}
          <span className="message">{item.message}</span>
        </li>
      ))}
    </ul>
  ) : null
}
